import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChevronRight, Package, SlidersHorizontal } from 'lucide-react';
import { Select } from '../ui';

const CategoryChoices = ({ remote, selected, onSelect }) => <div className="filter-group">
  <h3>Category</h3>
  <button data-testid="category-filter-all" className={!selected ? 'selected' : ''} onClick={() => onSelect('')}>
    All categories<ChevronRight size={13} />
  </button>
  {remote.data?.map(category => <button key={category.id} data-testid={`category-filter-${category.id}`}
    className={selected === category.id ? 'selected' : ''} onClick={() => onSelect(category.id)}>
    {category.name}<ChevronRight size={13} />
  </button>)}
  {remote.error && <div role="alert" data-testid="catalog-category-error">{remote.error}
    <button data-testid="catalog-category-retry" onClick={remote.reload}>Retry categories</button></div>}
</div>;

const SupplyFilters = ({ industry, packaging, update }) => <>
  <Select id="industry-filter" label="Industry" value={industry} onChange={event => update('industry', event.target.value)}>
    <option value="">All industries</option>
    {['Manufacturing', 'Construction', 'Logistics', 'Pharma', 'Textiles'].map(value => <option key={value}>{value}</option>)}
  </Select>
  <Select id="packaging-filter" label="Packaging" value={packaging} onChange={event => update('packaging', event.target.value)}>
    <option value="">All packaging</option>
    {['Box of 10', 'Carton', 'Wooden crate', 'Bundle of 25', 'Pallet', 'Drum', 'Service'].map(value => <option key={value}>{value}</option>)}
  </Select>
</>;

export const CatalogFilters = ({ model }) => <aside id="catalog-filters" className={`catalog-filters ${model.filtersOpen ? 'filters-open' : ''}`}>
  <div className="filter-heading"><SlidersHorizontal size={16} /><h2>Filter products</h2>
    <button data-testid="clear-filters" onClick={model.reset}>Reset</button></div>
  <CategoryChoices remote={model.categories} selected={model.params.get('category')} onSelect={model.selectCategory} />
  <SupplyFilters industry={model.params.get('industry') || ''} packaging={model.params.get('packaging') || ''} update={model.update} />
  <div className="filter-help"><Package size={22} /><h3>Not finding your part?</h3>
    <Link to="/rfq" data-testid="filter-rfq-link">Start a sourcing request<ArrowUpRight size={14} /></Link></div>
</aside>;